export function initAlgolia() {

    const searchClient = algoliasearch("5ME78R50J8", "4969f0b607b8e473b498ee2d1d0a982d");

    const search = instantsearch({
        indexName: "dataiku_global",
        searchClient,
        searchFunction(helper) {
            if (helper.state.query) {
                helper.search();
            }

        },
    });


    search.addWidget(
        instantsearch.widgets.searchBox({
            container: "#searchbox",
            limit: 5,
            showMore: true,
            autofocus: true,
            

        })
    );

    // This requires `tags` to be set in the `attributesForFacetings`
    // in your Algolia index settings
    search.addWidget(
        instantsearch.widgets.refinementList({
            container: "#tags-list",
            attribute: "tags",

        })
    );

    let template =  "<article>" +
        "<a href=\"\{\{ url \}\}\">" +
        "<strong>" +
        "\{\{\#helpers.highlight\}\}" +
        "\{ \"attribute\": \"title\", \"highlightedTagName\": \"mark\" \}" +
        "\{\{/helpers.highlight\}\}" +
        "</strong>" +
        "</a>" +
        "\{\{\#content\}\}" +
        "<p>\{\{\#helpers.snippet\}\}\{ \"attribute\": \"content\", \"highlightedTagName\": \"mark\" \}\{\{/helpers.snippet\}\}</p>" +
        "\{\{/content\}\}" +
        "</article>";

    search.addWidget(
        instantsearch.widgets.hits({
            container: "#search-results",
            templates: {
                item: template
            }
        })
    );



    search.start();
}


// WEBPACK FOOTER //
// ./assets/js/modules/init-algolia.js